<template>
  <SogPage
    id="page"
    :title="_title"
    flex-direction="flex-column"
  >
    <SogCard class="sog-card-without-title">
      <SogCardActions
        :with-badge="true"
        :is-toolbar="true"
      >
        <SogCardActionButton
          v-show="_searchVisible"
          mdi-icon="mdi-account-search"
          tooltip="Kunde suchen"
          @click="onSearch"
        />
        <SogBadge
          v-show="itemsCount>0"
          :value="itemsCount"
          badge-style="primary"
          badge-type="notification"
          overlap="true"
        >
          <SogCardActionButton
            mdi-icon="mdi-cart-outline"
            tooltip="Einkaufswagen"
            @click="_router.push('list')"
          />
        </SogBadge>
        <SogCardActionButton
          mdi-icon="mdi-cart-plus"
          tooltip="Neue Produkt hinzufügen"
          @click=" _router.push('add')"
        />
        <SogCardActionButton
          v-show="itemsCount>0"
          mdi-icon="mdi-cart-check"
          tooltip="Zur Kasse gehen"
          @click="_router.push('cashpoint')"
        />
        <SogCardActionButton
          :kind="SogButtonKind.Back"
        />
      </SogCardActions>
      <SogCardContent>
        <router-view />
      </SogCardContent>
    </SogCard>
  </SogPage>
</template>

<script setup lang="ts">
import SogPage from "@/shared/ui/SogPage.vue";
import {onBeforeRouteUpdate, RouteLocationNormalizedLoaded, useRoute, useRouter} from "vue-router";
import {useAccountStore} from "@/stores/accountStore";
import {onMounted, ref, watch} from "vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogBadge from "@/shared/ui/SogBadge.vue";

const _router = useRouter()
const _config = useAccountStore()

const _title = ref("");


const _shoppingCart = useShoppingCartStore();
const itemsCount = ref(_shoppingCart?.count ?? 0)
const _searchVisible = ref(false)
const _sector = ref("")

async function p_init(route: RouteLocationNormalizedLoaded) {

  const sector = route.params.sector as string;
  _sector.value = sector

  _title.value = "";
  if (sector === "purchase") {
    _title.value = "Einkauf"
    /*
        console.log("page")
        await _shoppingCart.initPurchase();
    */
  }
  if (sector === "sale") {
    _shoppingCart.initSale();
    if (_shoppingCart.currentShoppingCart.invoicePerson.Person.personName) {
      _title.value = "Verkauf an " + _shoppingCart.currentShoppingCart.invoicePerson.Person.personName
    } else {
      _title.value = "Verkauf"
    }
  }


}

watch((_shoppingCart), () => {
  itemsCount.value = _shoppingCart.count
  _searchVisible.value = _sector.value === "sale"// && _shoppingCart.currentShoppingCartId !== ""
})

onMounted(async () => {
  const route = useRoute();
  await p_init(route)
})

onBeforeRouteUpdate(async (to) => {
  const sector = to.params.sector as string;
  if (!_config.hasAction(sector)) {
    await _router.push("/")
    return
  }
  await p_init(to)
});


async function onSearch() {
  await _router.push({path: "add", query: {page: "person"}})
}


</script>
<style scoped>

</style>
